/*  ==========================================================================
    PHP Variables
    ========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
    Grid variables - needed for gridcarousel__init
    ========================================================================== */

  // NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
  var $grid_sizes = {
    sm: "550",
    md: "700",
    lg: "1000",
    xl: "1200",
    ws: "1400",
    xw: "1600"
  };

  /*  ==========================================================================
    Device Detection - Check if is mobile or ipad
    ========================================================================== */

var isMobile = false; // initiate as false
var isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  isMobile = true;
}
(function ($) {

  /*  ==========================================================================
			links
			========================================================================== */

  links__init();

  function links__init($context) {
    var $links = $("a").not(".noline, .noline a, .line--added");

    $links.each(function () {
      var $this = $(this);
      var $icon = $(".fa, .fas, .far, .fal, .fab", $this);

      if ($("img", $this).length < 1) {
        $this.wrapInner("<span class='linkline'>");
        $this.addClass("line--added");
        if ($icon.length > 0) {
          if ($icon.hasClass("fa--left")) {
            $icon.insertBefore($(".linkline", $this));
          } else {
            $icon.insertAfter($(".linkline", $this));
          }
        }
      }
    });
  } // links__init()

  /*  ==========================================================================
			sharinglinks
			========================================================================== */

  $(".sharelink--popup").click(function (e) {
    e.preventDefault();
    window.open($(this).attr("href"), "share-dialog", "width=550,height=436");
  });

  /*  ==========================================================================
			accordion
			========================================================================== */

  $(".accordion__question").click(function () {
    $(this).closest(".accordion__item").toggleClass("accordion__item--open");
  });

  /*  ==========================================================================
			Fancybox pop-ups
			========================================================================== */

  Fancybox.bind("[data-fancybox]", {
    Thumbs: false,
    Toolbar: {
      display: [
        { id: "counter", position: "left" },
        "zoom",
        //"slideshow",
        "fullscreen",
        "close"
      ]
    }
  });

  /*  ==========================================================================
    GENERAL - hide announcement banner on scroll 
    ========================================================================== */

  if ($(".announcement").length) {
    $("body").addClass("hassannouncement");
    $(window).scroll(function () {
      if ($(window).scrollTop() > 50) {
        $(".siteheader:not(.siteheader--padder)").addClass("siteheader--hideannouncement");
      } else {
        $(".siteheader:not(.siteheader--padder)").removeClass("siteheader--hideannouncement");
      }
    });
  }
  /*  ==========================================================================
    Quotes
    ========================================================================== */

  var $quotes = $(".quotes .owl-carousel");

  if ($quotes.length > 0) {
    quotes__init();
  }

  function quotes__init() {
    $quotes.each(function () {
      var $this = $(this);
      $this
        .on("changed.owl.carousel", function (event) {
          var currentItem = event.item.index + 1;
          $(".owl-index").find(".current").text(currentItem);
          // Waypoint.refreshAll();
          setTimeout(function () {
            Waypoint.destroyAll();
            effects__init();
          }, 2000);
        })
        .on("resized.owl.carousel", function () {
          $this.trigger("next.owl.carousel");
          //  Waypoint.refreshAll();
        })
        .owlCarousel({
          loop: false,
          nav: true,
          dots: false,
          items: 1,
          autoHeight: true,
          navText: ["<i class='far fa-chevron-left'></i>", "<i class='far fa-chevron-right'></i>"]
        });
    });
  } // quotes__init()

  /*  ==========================================================================
    Publications Carousel
    ========================================================================== */

  /*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

  var default_animation_speed = 1.5;

  var el_class = "marquee";
  var inner_class = "marquee__wrap";

  $("." + el_class).each(function () {
    marquee__init($(this));
  });

  $(window).resize(function () {
    $("." + el_class).each(function () {
      marquee__resize($(this));
    });
  });

  function marquee__init($el) {
    // Setup two scroll wraps (duplicate the HTML)
    $el.wrapInner("<div class='" + inner_class + "'></div>");
    $el
      .find("." + inner_class)
      .clone()
      .appendTo($el);
    $el
      .find("." + inner_class + ":first-child()")
      .clone()
      .appendTo($el);
    $el
      .find("." + inner_class + ":first-child()")
      .clone()
      .appendTo($el);
    $el
      .find("." + inner_class + ":first-child()")
      .clone()
      .appendTo($el);

    //lazyLoadInstance.update(); // reinit lazy load after clones

    // Setup animation times
    marquee__resize($el);

    // Once everything is set up, add "loaded" class
    $el.addClass(el_class + "--loaded");
  }

  function marquee__resize($el) {
    // Check if element has custom speed or default
    var animation_speed = default_animation_speed;
    if ($el.data("speed")) {
      animation_speed = $el.data("speed");
    } else {
      animation_speed = default_animation_speed;
    }

    // Set animation time
    var linelength = $("." + inner_class, $el).width();
    var distance = linelength;
    var speed = animation_speed * 0.01;
    var duration = distance / speed;
    var delay = 0 - duration / 3;

    $el.find("." + inner_class).css("animation-duration", duration + "ms");
    $el.find("." + inner_class + ":first-child()").css("animation-delay", delay + "ms");
    $el.find("." + inner_class + ":nth-child(2)").css("animation-delay", delay * 2 + "ms");
    $el.find("." + inner_class + ":nth-child(3)").css("animation-delay", delay * 3 + "ms");
    $el.find("." + inner_class + ":nth-child(4)").css("animation-delay", delay * 4 + "ms");
    $el.find("." + inner_class + ":nth-child(5)").css("animation-delay", delay * 5 + "ms");
  }

  // var $publications = $(".publications");

  // if ($publications.length > 0) {
  //   publications__init();
  // }

  // function publications__init() {
  //   $publications
  //     .owlCarousel({
  //       loop: true,
  //       nav: false,
  //       dots: false,
  //       autoplay: true,
  //       responsiveClass: true,
  //       slideTransition: "linear",
  //       transitionStyle: "fade",
  //       smartSpeed: 6000,
  //       animateIn: "linear",
  //       animateOut: "linear",
  //       lazyLoad: true,
  //       responsive: {
  //         0: {
  //           items: 2
  //         },
  //         550: {
  //           items: 3
  //         },
  //         700: {
  //           items: 4
  //         },
  //         1000: {
  //           items: 5
  //         },
  //         1200: {
  //           items: 6
  //         }
  //       }
  //     })
  //     .waypoint({
  //       handler: function (direction) {
  //         if (direction === "down" && $publications.data("alreadyscrolled") !== "true") {
  //           $publications.trigger("next.owl.carousel").data("alreadyscrolled", "true");
  //         }
  //       },
  //       offset: "50%"
  //     });

  //   $publications.on("resized.owl.carousel", function () {
  //     $publications.trigger("next.owl.carousel");
  //   });
  // } // publications__init()

  /*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts)
			========================================================================== */

  var $grid_carousels = $(".row--carousel .owl-carousel");

  if ($grid_carousels.length > 0) {
    gridcarousel__init();
  }

  function gridcarousel__init() {
    $grid_carousels.each(function () {
      var $this = $(this);
      var $this_slidecount = $(".col", $this).length;
      if ($this_slidecount > 1) {
        // create resonsive array from col classes
        var classList = $this.find(".col").attr("class").split(/\s+/);
        var responsive_array = {};
        $.each(classList, function (index, item) {
          // if is col width class
          if (item.indexOf("col-") !== -1) {
            var item_width = 0;
            var items_items = 4;
            item = item.replace("col-", "");
            // get min width from col class
            let item_gridsize = item.split("-")[0];
            // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
            if (isNaN(item_gridsize)) {
              item = item.replace(item_gridsize + "-", "");
              item_width = $grid_sizes[item_gridsize];
            } else {
              item_width = 0;
            }
            // split rest of class into sections (this should now be something like "1-4")
            let item_class_sections = item.split("-");
            // divide second number (e.g 4) by first number (e.g 1) to get number of items
            var item_items = "";
            if (item_class_sections[1]) {
              item_items = item_class_sections[1] / item_class_sections[0];
            } else {
              item_items = 1; // if there isn't a second number it must be a single grid
            }
            responsive_array[item_width] = {
              items: item_items
            };
          }
        });
        if ($this.parents(".row--carousel--images").length) {
          $this.owlCarousel({
            loop: true,
            nav: false,
            dots: false,
            autoWidth: true
          });
          // }else if ($this.parents(".publications__gallery").length) {
          //   $this.owlCarousel({
          //     loop: true,
          //     nav: false,
          //     dots: false,
          //     autoplay: true,
          //     responsiveClass: true,
          //     slideTransition: "linear",
          //     smartSpeed: 6000,
          //     rtl: true,
          //     items: 4,
          //     responsive: responsive_array,
          //     startPosition: $this_slidecount,
          //     autoHeight: true,
          //     lazyLoad: true
          //   });
        } else {
          $this.owlCarousel({
            loop: false,
            nav: true,
            dots: false,
            items: 4,
            // navText: ["<i class='far fa-chevron-left'></i>", "<i class='far fa-chevron-right'></i>"],
            navText: ["<i class='fal fa-arrow-left'></i>", "<i class='fal fa-arrow-right'></i>"],
            responsive: responsive_array,
            startPosition: $this_slidecount,
            autoHeight: true
          });
        }
      }
    });
  } // gridcarousel__init()

  /*  ==========================================================================
			pageheaderhero slides
			========================================================================== */

  var $hero = $(".pageheader--frontpage .owl-carousel");

  if ($hero.length > 0) {
    hero__init();
  }

  function hero__init() {
    var timeout = $hero.data("timeout");
    $hero.each(function () {
      var $this = $(this);
      var $this_slidecount = $(".pageheader__slide", $this).length;
      if ($this_slidecount > 1) {
        $this
          .owlCarousel({
            loop: true,
            animateOut: "fadeOut",
            nav: true,
            dots: false,
            items: 1,
            startPosition: $this_slidecount,
            autoHeight: false,
            autoplay: true,
            autoplayTimeout: timeout
          })
          .on("change.owl.carousel", function (event) {
            var item = event.item.index;
            if ($(".owl-item.active").find(".pageheader--video").length) {
              var soundbtn = $(".owl-item.active").find(".herovideosound");
              if (soundbtn.hasClass("soundon")) {
                soundbtn.trigger("click");
              }
            }
          });
      }
    });
  } // hero__init()

  $(".pageheader--video").each(function (e) {
    var iframe = $(this).find(".pageheadervideo__iframe--vimeo"),
      parent = $(this);

    var player = new Vimeo.Player(iframe);
    player.setVolume(0);
    player.ready().then(function () {
      player.play();

      // player.on("play", function () {
      // 	console.log("played the video!");
      // });

      parent.find(".herovideosound").on("click", function () {
        if (!$(this).hasClass("soundon")) {
          player
            .setMuted(false)
            .then(function (muted) {
              // console.log('muted was turned off');
            })
            .catch(function (error) {
              //console.log("an error occurred");
            });
          player
            .setVolume(0.5)
            .then(function (volume) {
              // volume was set
              //console.log('Volume Set');
            })
            .catch(function (error) {
              switch (error.name) {
                case "RangeError":
                  // the volume was less than 0 or greater than 1
                  //	console.log("RangeError");
                  break;

                default:
                  // some other error occurred
                  break;
              }
            });
        } else {
          player.setVolume(0);
        }
        $(this).toggleClass("soundon");
      });
    });
  });

  //   $(".herovideosound").on("click", function () {
  //       $(".herovideosound").toggleClass("soundon");
  //     var iframe = $(this).parents(".pageheader__bg").find(".pageheadervideo__iframe--vimeo")[0];

  //     var player = new Vimeo.Player(iframe);

  //     player.setVolume(.5);

  //   // if ($(this).hasClass("soundon")) {
  //   //   iframe.contentWindow.postMessage('{"method":"setVolume", "value":1}', "*");
  //   // } else {
  //   //   iframe.contentWindow.postMessage('{"method":"setVolume", "value":0}', "*");
  //   // }
  // });

  /*  ==========================================================================
			pageheader gallery
			========================================================================== */

  var $pageheader__gallery = $(".pageheader__gallery");

  if ($pageheader__gallery.length > 0) {
    gallery__init();
  }

  function gallery__init() {
    $pageheader__gallery.each(function () {
      var $this = $(this);
      var $this_slidecount = $(".pageheader__gallery__img", $this).length;
      if ($this_slidecount > 1) {
        $this.owlCarousel({
          loop: true,
          animateOut: "fadeOut",
          nav: false,
          dots: false,
          items: 1,
          startPosition: $this_slidecount,
          autoHeight: false,
          autoplay: true,
          autoplayTimeout: 7000
        });
      }
    });
  } // gallery__init()

  /*  ==========================================================================
			effects
			========================================================================== */

  var $effects = $(".effect");

  if ($effects.length > 0) {
    effects__init();
  }

  function effects__init() {
    $effects.each(function () {
      var $el = $(this);
      $el.waypoint({
        handler: function (direction) {
          if (direction === "down") {
            $el.addClass("effect--ready");
          } else {
            $el.removeClass("effect--ready");
          }
        },
        offset: "90%"
      });
    });
  } // effects__init()

  /*  ==========================================================================
			pageheader video background
			========================================================================== */

  // Fade in page header video when ready
  if ($("#pageheadervideo__iframe").length) {
    var iframe = document.getElementById("pageheadervideo__iframe");
    var player = new Vimeo.Player(iframe);
    player.ready().then(function () {
      $("body").addClass("pageheader-video-playing");
    });
  }

  /*  ==========================================================================
			AJAX load more / paging
			========================================================================== */

  $(".paging__loadmore").click(function () {
    var button = $(this);
    var data = {
      action: "loadmore",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function
      page: php_variables.current_page
    };
    var button_text; // create variable to store button text

    // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
    $.ajax({
      url: php_variables.ajax_url, // AJAX handler
      data: data,
      type: "POST",
      beforeSend: function (xhr) {
        button_text = button.html(); // store current button text
        button.text("Loading..."); // change the button text, to let the user know we are loading more posts
      },
      success: function (data) {
        if (data) {
          button.html(button_text); // set back to previous button text
          $(".loadmore-container").append(data); // insert new posts to the loadmore-container, this should be the row that includes the posts
          php_variables.current_page++;
          // if last page, remove the button..
          if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
            button.remove();
          }
          // Re-init links to make sure linklines on newly loaded content still work
          links__init();
        } else {
          button.remove(); // if no data, remove the button as well
        }
      }
    });
  });

  /*  ==========================================================================
			Search open
			========================================================================== */

  // Search open & close
  if ($(".siteheader__search").length) {
    $(".search-toggle").click(function () {
      $mobnav.height(0);
      $("body").removeClass(mobnavopenclass);
      if ($(this).closest(".siteheader").find(".siteheader__search").hasClass("siteheader__search--open")) {
        $(this).closest(".siteheader").find(".siteheader__search").removeClass("siteheader__search--open");
      } else {
        $(this).closest(".siteheader").find(".siteheader__search").addClass("siteheader__search--open");
        $(this).closest(".siteheader").find(".siteheader__search .searchform__input input").focus();
      }
    });
  }

  // Hide search when clicking anywhere else on the page
  $(document).mouseup(function (e) {
    var search_container = $(".siteheader__search");
    var search_toggle = $(".search-toggle");
    if (
      !search_container.is(e.target) &&
      search_container.has(e.target).length === 0 &&
      !search_toggle.is(e.target) &&
      search_toggle.has(e.target).length === 0
    ) {
      $(search_container).removeClass("siteheader__search--open");
    }
  });

  /*  ==========================================================================
			NAVIGATION - mobnav
			========================================================================== */

  var $mobnav = $(".mobnav");
  var $siteheaderbd = $(".siteheader__bd");
  var $mobnavtoggle = $(".mobnav-toggle");
  var mobnavopenclass = "mobnavopen";

  mobnav__init();

  function mobnav__init() {
    // Open mobnav on click the toggle
    $mobnavtoggle.on("click touchend", function (e) {
      e.preventDefault();
      if (!$("body").hasClass(mobnavopenclass)) {
        // IT'S NOT OPEN...
        var $mobnav_height = window.innerHeight - $siteheaderbd.outerHeight(false);
        $mobnav.height($mobnav_height);
        $("body").addClass(mobnavopenclass);
      } else {
        // IT'S OPEN...
        $mobnav.height(0);
        $("body").removeClass(mobnavopenclass);
      }
    });

    $(window).resize(mobnav__resize);
  } // mobnav__init()

  // On resize check mobnav height is still right
  function mobnav__resize() {
    if ($("body").hasClass(mobnavopenclass)) {
      var $mobnav_height = window.innerHeight - $siteheaderbd.outerHeight(false);
      $mobnav.height($mobnav_height);
    }
  } // mobnav__resize()

  /*  ==========================================================================
			NAVIGATION - mobnav dropdowns
			========================================================================== */

  $(".mobnav .mobnav__section.has-dropdown .mobnav__section__toggle").click(function (e) {
    e.preventDefault();
    $(this).closest(".mobnav__section").toggleClass("mobnav__section--open");
  });

  $(".mobnav .sitenavsection__submenu__link__toggle").click(function (e) {
    e.preventDefault();
    $(this).parent().toggleClass("active");
  });

  $(".mobnav .sitenavsection__submenu > li > span").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
  });

  /*  ==========================================================================
      NAVIGATION - sitenav dropdowns
      ========================================================================== */

  var $siteheader = $(".siteheader");
  var $sitenav = $(".sitenav");
  var $sitenavitems = $("li[data-sitenavsection]", $sitenav).not(".hover-avoid");
  var $sitenavdropdown = $(".sitenav__dropdown");
  var $body = $("body");

  var overclass = "sitenav__item--over";
  var navopenbodyclass = "sitenavopen";
  var activesectionclass = "sitenavsection--active";

  var navopen = false;
  var $currentli = false;
  var dropdownclosetimer = false;

  // Check if isMobile, and only init if desktop or Ipad
  if (!isMobile) {
    sitenav__init();
  }

  function sitenav__init() {
    // Check if is touchscreen and setup dropdown to show on tap as well as hover
    if (isTouchDevice) {
      // IF TOUCHSCREEN (e.g. Ipad users)...
      // Setup dropdown to show on tap
      $sitenavitems.on("tap click hover", function (e) {
        $this = $(this);
        e.preventDefault();
        if ($this.hasClass(overclass)) {
          navopen = false;
          sitenav__close();
        } else {
          sitenavsection__open($this);
        }
      });
    } else {
      // IF DESKTOP...
      $sitenavitems.mouseover(sitenavitem__over).mouseout(sitenav__out);
      $sitenavdropdown.mouseover(sitenavsection__over).mouseout(sitenav__out);
    }
  } // sitenav__init()

  function sitenavitem__over() {
    // On hover of sitenav item
    sitenavsection__open($(this));
  } // sitenavitem__over()

  function sitenavsection__open($target_li) {
    var $targetsection = $sitenavdropdown.find(".sitenavsection--" + $target_li.attr("data-sitenavsection"));
    var dropdown_height = $sitenavdropdown.find(".sitenavsection--" + $target_li.attr("data-sitenavsection")).height();

    // Make dropdown show and set classes to say it's open
    $sitenavdropdown.css("height", dropdown_height);
    navopen = true;
    if (dropdownclosetimer) {
      // Clear timeout to stop dropdown closing
      window.clearTimeout(dropdownclosetimer);
    }
    $("." + overclass, $sitenav).removeClass(overclass);
    $target_li.addClass(overclass);
    $body.addClass(navopenbodyclass);
    $currentli = $target_li;
    $("." + activesectionclass).removeClass(activesectionclass);
    $targetsection.addClass(activesectionclass);
  } //sitenavsection__open();

  function sitenavsection__over() {
    // On hover of sitenavsection, keep the dropdown open
    navopen = true;
    if (dropdownclosetimer) {
      // Clear timeout to close the dropdown
      window.clearTimeout(dropdownclosetimer);
    }
    $body.addClass(navopenbodyclass);
  } // sitenavitem__over()

  function sitenav__out() {
    // On leave sitenav hover
    navopen = false;
    // Start timeout to close sitenav dropdown
    dropdownclosetimer = window.setTimeout(sitenav__close, 250);
  } // sitenavitem__over()

  function sitenav__close() {
    // when time out ends and nav open is still false, close the sitenav
    if (!navopen) {
      // Set height to 0 and remove classes
      $("." + activesectionclass).removeClass(activesectionclass);
      $body.removeClass(navopenbodyclass);
      if ($currentli) {
        $currentli.removeClass(overclass);
      }
      $sitenavdropdown.css("height", 0);
    }
  } // sitenav__close

  /*  ==========================================================================
			Product Tile select size
			========================================================================== */

  $(document).on("click", ".btn__selectsize", product__selectsize);

  function product__selectsize(e) {
    var btn = $(this);
    btn.parents(".product__addtocart").toggleClass("showsizes");
  }

  /*  ==========================================================================
	    Add to Cart
	    ========================================================================== */

  $(document).on("click", ".addtocartlink", product__addtocart);

  function product__addtocart(e) {
    e.preventDefault();

    var variantID = $(this).data("id");
    var productbtn = $(this).parents(".product__addtocart");

    $.ajax({
      dataType: "jsonp",
      url: "https://shop.paolita.co.uk/cart/add.json?quantity=" + 1 + "&id=" + variantID + "&callback=?",
      success: function (data, textStatus ,xhr) {
        /* do something with the data. */
        cart__load();
        // After the Shopify AddToCart JSONP request has succeeded call trigger php function that
        // sends the AddToCart event to Meta CAPI
        try {
          let response = xhr.responseJSON;
          if (response && response.id) {
              // Send data to WordPress
              jQuery.post(php_variables.ajax_url, {
                  action: 'meta_capi_addtocart',
                  product_id: response.id,
                  price: response.price ? response.price / 100 : 0, // Shopify price in cents
                  currency: response.currency || 'GBP'
              });
          }
        } catch(e) {
            console.error('Meta CAPI AddToCart tracking failed', e);
        }
        

        if (productbtn.find(".btn__addtocart") && productbtn.find(".btn__addtocart").length > 0) {
          productbtn.find(".btn__addtocart").addClass("bg-pink");
        } else {
          productbtn.toggleClass("showsizes");
          productbtn.find(".btn__selectsize").addClass("bg-pink");
        }

        productbtn.find(".addcarttext").text("Added to cart");

        setTimeout(function () {
          productbtn.find(".addcarttext").text("Add to cart");
          if (productbtn.find(".btn__addtocart") && productbtn.find(".btn__addtocart").length > 0) {
            productbtn.find(".btn__addtocart").removeClass("bg-pink");
          } else {
            productbtn.find(".btn__selectsize").removeClass("bg-pink");
          }
        }, 3000);
      }
    });
  }

  /*  ==========================================================================
	    Load Cart
	    ========================================================================== */

  function cart__load() {
    $.ajax({
      type: "GET",
      url: "https://shop.paolita.co.uk/cart.json",
      dataType: "jsonp",
      success: function (cart) {
        if (cart.item_count > 0) {
          $(".shoppingcartcount").attr("data-cartempty", false);
          $(".shoppingcartcount span.cartcount").html(cart.item_count);
          // $(".mobcart__count").html(cart.item_count);

          cartreminder__display();
        } else {
          $(".shoppingcartcount").attr("data-cartempty", true);
          $(".shoppingcartcount span.cartcount").html("");
          return;
        }
      }
    });
  }

  cart__load();

  /*  ==========================================================================
	    Cart Reminder
	    ========================================================================== */

  function cartreminder__display() {
    if ($(".cartreminder") && $(".cartreminder").length > 0) {
      setTimeout(function () {
        $(".cartreminder").fadeIn();
      }, 15000);

      $(".cartreminder__close").click(function () {
        cartreminder__close();
      });
    }
  }

  function cartreminder__close() {
    if ($(".cartreminder") && $(".cartreminder").length > 0) {
      $(".cartreminder").fadeOut();
    }
  }

  /*  ==========================================================================
			Polyfill IE11 for forEach
			========================================================================== */

  if ("NodeList" in window && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
      thisArg = thisArg || window;
      for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  }

  /*  ==========================================================================
			patterns accordion
			========================================================================== */

  $(".pattern__titlewrap").click(function () {
    $(this).closest(".pattern__item").toggleClass("pattern__item--open");

    // Scroll back to the pattern on close
    if (!$(this).closest(".pattern__item").hasClass("pattern__item--open")) {
      var patternPosition = $(this).closest(".pattern__item").offset().top - $(".siteheader").outerHeight();
      $("html, body").animate({ scrollTop: patternPosition }, 500);
    }

    effects__init();
  });

    // /*  ==========================================================================
    // HEADER - Enable masonry grids on sitenavsections for the new navigation
    // ========================================================================== */

    var $masonrygrids = $(".sitenavsection");

    if ($masonrygrids.length > 0) {
      grids__init();
    }
  
    function grids__init() {
      $masonrygrids.each(function () {
        var $el = $(this);
        var masonryOptions = {
          // set itemSelector so .grid-sizer is not used in layout
          itemSelector: ".col",
          // use element for option
          columnWidth: ".col-sizer",
          percentPosition: true
        };
  
        $el.find(".post-grid").masonry(masonryOptions);
  
        $(window).on("load resize", function () {
          if ($(window).width() < 1200) {
            $el.find(".post-grid").masonry().masonry("destroy");
          } else {
            $el.find(".post-grid").masonry().masonry(masonryOptions);
          }
        });
      });
    } // grids__init()


// /*  ==========================================================================
// PAGEHEADER - Front page snap sections setup
// ========================================================================== */

  // Select all slide snap elements
  const pageheader__snap = document.querySelector(".pageheader__snap");
  var $el = $(".snap__end");
  $el.waypoint({
    handler: function (direction) {
      // Prevent default scroll action when hovering over slide snap elements
      if (direction === "down") {
        pageheader__snap.classList.add("active");
      } else {
        pageheader__snap.classList.remove("active");
      }
    },
    offset: "100%"
  });
})(jQuery); // Domready
